import Alert from '@amzn/awsui-components-react/polaris/alert';
import Box from '@amzn/awsui-components-react/polaris/box';
import { ErrorPage } from '@amzn/event-engine-js-utils';
import React from 'react';

const NotFoundErrorPage = () => <ErrorPage type="404" />;

export type ErrorType =
    | '404'
    | 'catastrophic'
    | 'embedded-build-catastrophic-error';

interface IErrorPageController {
    type: ErrorType;
}

const CatastrophicComponent = (): JSX.Element => {
    return (
        <Alert
            type="error"
            dismissible={false}
            header="Something went wrong"
            data-testid="catastrophic-component"
            dismissAriaLabel={
                'Something went wrong, please refresh the page or try again later.'
            }>
            Please refresh the page or try again later.
        </Alert>
    );
};

const EmbeddedBuildCatastrophicError = (): JSX.Element => {
    return (
        <Alert
            type="error"
            dismissible={false}
            header="Something went wrong"
            data-testid="embedded-build-catastrophic-error">
            There was a problem displaying this workshop. Please refresh the
            page or try again later.
        </Alert>
    );
};

const ErrorPageMap: Record<ErrorType, JSX.Element> = {
    '404': <NotFoundErrorPage />,
    catastrophic: <CatastrophicComponent />,
    'embedded-build-catastrophic-error': <EmbeddedBuildCatastrophicError />,
};

const ErrorPageController = ({ type }: IErrorPageController) => {
    const errorComponent = ErrorPageMap[type] || <NotFoundErrorPage />;

    return <Box padding={{ vertical: 's' }}>{errorComponent}</Box>;
};

export default ErrorPageController;
